__turbopack_context__.v({
  "h1": "styleConstants-module__oqvZeq__h1",
  "h1_opt": "styleConstants-module__oqvZeq__h1_opt",
  "h2": "styleConstants-module__oqvZeq__h2",
  "h2Small": "styleConstants-module__oqvZeq__h2Small",
  "h2_opt": "styleConstants-module__oqvZeq__h2_opt",
  "h3": "styleConstants-module__oqvZeq__h3",
  "leftSideTextWrapper": "styleConstants-module__oqvZeq__leftSideTextWrapper",
  "p": "styleConstants-module__oqvZeq__p",
  "pBody": "styleConstants-module__oqvZeq__pBody",
  "pLarge": "styleConstants-module__oqvZeq__pLarge",
  "pLargeGradient": "styleConstants-module__oqvZeq__pLargeGradient",
  "p_opt": "styleConstants-module__oqvZeq__p_opt",
});
